import { Link } from "react-router-dom";

interface PopularItem {
  to: string;
  title: string;
  meta: string;
}

interface PopularPanelProps {
  title: string;
  icon: string;
  moreTo: string;
  items: PopularItem[];
}

export default function PopularPanel({ title, icon, moreTo, items }: PopularPanelProps) {
  return (
    <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
            <i className={`${icon} text-base`}></i>
          </span>
          {title}
        </h3>
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-xs font-medium text-foreground-500 transition hover:text-primary-700"
        >
          更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <ul className="space-y-1">
        {items.map((item, index) => (
          <li key={item.to}>
            <Link
              to={item.to}
              className="group flex items-start gap-3 rounded-xl px-2 py-2.5 transition hover:bg-primary-50"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${
                  index < 3
                    ? "bg-primary-500 text-foreground-950"
                    : "bg-background-100 text-foreground-500"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">
                  {item.meta}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}